//@flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Text } from '@locus-taxy/neo-ui';

import LoginButton from './LoginButton';
import useResolvedClientId from 'common/hooks/useResolvedClientId';

import ClientIdForm from './ClientIdForm';

const LoginFragment = (): React.Node => {
    const { t } = useTranslation('settings');
    const { clientIdFromQuery, clientIdFromHostName } = useResolvedClientId();

    if (!clientIdFromQuery && !clientIdFromHostName) {
        return <ClientIdForm />;
    }
    return (
        <Stack space="large">
            <Text fontSize={2} textAlign="center">
                {t('loginLandingMessage')}
            </Text>
            <LoginButton />
        </Stack>
    );
};

export default LoginFragment;
